module.exports = __webpack_public_path__ + "img/productivity.77e76dc7.png";